import React from "react";
import { Link } from "react-router-dom";
import "../../Styles/tvReportCard.css";
import ExamModalCart from "../../Components/Alerts/ExamModalCart";
import { useState } from "react";

const TvKnowledgeReportCard = ({
  toptext,
  getPoint,
  buttonLink,
  result,
  correct,
  finishExamMessage,
}) => {
  //exam modal status
  const [examModalStatus, setExamModalStatus] = useState(false);

  //route to Exam
  const [routeInfo, setRouteInfo] = useState({
    id: "",
    bookName: "",
    remainedExam: "",
  });

  const handleOpenModalExam = (id, bookName, remainedExam) => {
    setRouteInfo({
      id,
      bookName,
      remainedExam,
    });
    setExamModalStatus(true);
  };

  const handleRouteToExam = () => {
    window.location.reload();
  };

  return (
    <>
      <div className="FalseTrue FalseTrue-tv-Plus">
        <div className="tv-plus-result-modal">
          <h2
            style={getPoint ? { color: "#FAE261" } : { color: "#F96D6D" }}
            className="tv-plus-result-modal-title"
          >
            {toptext}
          </h2>
          <div className="tv-introduction-card-side-left">
            {/* btn 1 */}
            <div className="tv-introduction-card-score-btn">
              {getPoint ? (
                <div>
                  <span>
                    تونستی {correct ? correct * 30 : 0} امتیاز از این آزمون
                    بگیری
                  </span>
                  <img
                    src="/imgs/bashgah/bashgah-group.svg"
                    alt="diamond-image"
                  />
                </div>
              ) : (
                <span>{finishExamMessage}</span>
              )}
            </div>
            {/* btn 2 */}
            {result?.yourScore === result?.allScore ? (
              <div
                style={{ backgroundColor: "#05786e" }}
                className="tv-introduction-card-lock-btn"
              >
                <span>دیگه نیاز نیست برای این آزمون تلاش کنی!</span>
                <img src="/imgs/hisstoriPlus/lock-icon.svg" alt="lock-image" />
              </div>
            ) : result?.isActive === false ? (
              <div
                style={{ backgroundColor: "#99A1E5" }}
                className="tv-introduction-card-lock-btn"
              >
                <span>به زودی...</span>
                <img src="/imgs/hisstoriPlus/lock-icon.svg" alt="lock-image" />
              </div>
            ) : result?.remainedExam === 0 ? (
              <div
                style={{ backgroundColor: "#FB6161" }}
                className="tv-introduction-card-lock-btn"
              >
                <span>دیگه نمی‌تونی برای این آزمون تلاش کنی</span>
                <img src="/imgs/hisstoriPlus/lock-icon.svg" alt="lock-image" />
              </div>
            ) : result?.isSuccess === true ? (
              <div
                style={{ backgroundColor: "#483C97" }}
                className="tv-introduction-card-lock-btn"
              >
                <span>آفرین! این آزمون رو با موفقیت گذروندی</span>
                <img src="/imgs/hisstoriPlus/lock-icon.svg" alt="lock-image" />
              </div>
            ) : (
              <div
                onClick={() =>
                  handleOpenModalExam(
                    result.id,
                    result.book,
                    result.remainedExam
                  )
                }
                style={
                  result?.remainedExam < result?.allowAttempt
                    ? { backgroundColor: "#02948A" }
                    : { backgroundColor: "#20724B" }
                }
                className="tv-introduction-card-lock-btn"
              >
                <span>
                  {result?.remainedExam < result?.allowAttempt
                    ? "هنوز می‌تونی برای این آزمون تلاش کنی"
                    : "شروع آزمون"}
                </span>
                <img
                  src="/imgs/hisstoriPlus/unlock-icon.svg"
                  alt="lock-image"
                />
              </div>
            )}
            {/* btn 3 */}
            <Link to={buttonLink}>
              <div className="tv-introduction-card-back-btn">
                <span style={{ color: "#fff" }}>برگرد به صفحه مسابقه</span>
              </div>
            </Link>
          </div>
        </div>
      </div>
      {examModalStatus && (
        <ExamModalCart
          handleRoute={() => handleRouteToExam()}
          close={() => setExamModalStatus(false)}
          image={"/imgs/hisstoriPlus/examPic.svg"}
          remainedExam={routeInfo.remainedExam}
        />
      )}
    </>
  );
};

export default TvKnowledgeReportCard;
